export default {
  meta: {
    title: '打卡统计',
    url: '/storemanage/attendance' // 埋点用，记录所属模块
  },
};
